import { Checkbox } from "primereact/checkbox";
import { INode } from "../..";
import { Dropdown } from "primereact/dropdown";
import { CheckAllProductTemplateStyled, DropdownCheckTemplate } from "./styled";
import { useEffect, useState } from "react";

interface ICheckAllProductTemplate {
    checkAll: boolean;
    nodes: INode[];
    checkAllMethod: (insideCheck: boolean, _nodes: INode[], clearSelection?: boolean) => void;
    handleChangeCheckAllType: (value: any) => void;
}
export const CheckAllProductTemplate: React.FC<ICheckAllProductTemplate> = (props) => {
    const { checkAll, nodes, checkAllMethod, handleChangeCheckAllType } = props;
    const [selectedValue, setSelectedValue] = useState(null);

    const optionsItems = [
        { name: "Todos" },
        { name: "Publicados" },
        { name: "Despublicados" },
        { name: "Ativos" },
        { name: "Inativos" },
    ];

    useEffect(() => {
        handleChangeCheckAllType(selectedValue);
    }, [selectedValue])

    const handleCheckboxSelect = (event: any, nodes: any) => {
        event.stopPropagation();
        event.preventDefault();

        if(event.checked === false && handleChangeCheckAllType){
            setSelectedValue(null);
			handleChangeCheckAllType(null);
		}

        checkAllMethod(event.checked, nodes);
    };

    const handleChangeValue = (value: any) => {
        if(value !== selectedValue){
            setSelectedValue(value);

            let nodeList = nodes
            switch (value){
                case "Publicados":
                    nodeList = handlePublishFilter(nodeList, true)
                    break;
                case "Despublicados":
                    nodeList = handlePublishFilter(nodeList, false)
                    break;
                case "Ativos":
                    nodeList = handleStatusFilter(nodeList, true)
                    break;
                case "Inativos":
                    nodeList = handleStatusFilter(nodeList, false)
                    break;
            }
    
            checkAllMethod(true, nodeList, true);
        }
        
    };

    const handlePublishFilter = (nodeList: any, value: boolean) => {
        let filterList =  nodeList.filter((i: any) => i.data.is_published === value);
        return filterList
    }

    const handleStatusFilter = (nodeList: any, value: boolean) => {
        let filterList =  nodeList.filter((i: any) => i.data.is_active === value);
        return filterList
    }

    return (
        <CheckAllProductTemplateStyled>
            <div className="p-inputgroup">
                <span className="p-inputgroup-addon">
                    <Checkbox
                        tooltip={checkAll ? "Limpar seleção nesta página" : "Selecionar todos nesta página"}
                        tooltipOptions={{ position: "top" }}
                        checked={checkAll}
                        onChange={(e) => handleCheckboxSelect(e, nodes)}
                    />
                </span>
                <DropdownCheckTemplate
                    value={selectedValue}
                    options={optionsItems}
                    optionLabel="name"
                    optionValue="name"
                    onChange={(e) => handleChangeValue(e.value)}
                />
            </div>

            {/* <Checkbox
                tooltip={checkAll ? "Limpar seleção nesta página" : "Selecionar todos nesta página"}
                tooltipOptions={{ position: "top" }}
                checked={checkAll}
                onChange={(e) => checkAllMethod(e.checked, nodes)}
            /> */}
        </CheckAllProductTemplateStyled>
    );
};
